var map = {
	"./progress-ellipse-au.svg": 1989,
	"./progress-ellipse-ca.svg": 119,
	"./progress-ellipse-global.svg": 2750,
	"./progress-ellipse-nz.svg": 4215,
	"./progress-ellipse-sg.svg": 3766,
	"./progress-ellipse-us.svg": 1535
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 743;